import React from 'react';
import { injectIntl } from 'react-intl';

import A from 'components/A';

import { Layout } from 'antd';

import './style.css';

const {
  Footer,
} = Layout;

const SignedInFooter = ({ intl }) => {
  const t = intl.messages;
  return (
    <Footer className="Footer">
      <div>{ t.footer_contact_us_info }</div>
      <div>
        <A href="mailto:voluntariado.empresa@entrajuda.pt">voluntariado.empresa@entrajuda.pt</A>
      </div>
    </Footer>
  );
}

export default injectIntl(SignedInFooter);
